import { createContext, useContext, useMemo } from 'react';
import usePersistentPageSize from 'hooks/usePersistentPageSize';

const PageSizeContext = createContext(null);

export function PageSizeProvider({ children, storageKey = 'global', defaultPageSize = 100 }) {
  const { pageSize, setPageSize, pageSizeOptions, hasStoredValue } = usePersistentPageSize(storageKey, defaultPageSize);

  const value = useMemo(
    () => ({
      pageSize,
      setPageSize,
      pageSizeOptions,
      hasStoredValue
    }),
    [pageSize, setPageSize, pageSizeOptions, hasStoredValue]
  );

  return <PageSizeContext.Provider value={value}>{children}</PageSizeContext.Provider>;
}

export function usePageSizeContext() {
  return (
    useContext(PageSizeContext) || {
      pageSize: 100,
      setPageSize: () => {},
      pageSizeOptions: [100, 250, 500],
      hasStoredValue: false
    }
  );
}


